import React from 'react';
import filter from 'lodash/filter';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { withRouter } from 'react-router';
// import Select from 'react-select';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import SuperAdminSubscriptionItem from './SubscriptionItem';
import Loading from '../../components/Loading';

const availablePlans = organizationPlans =>
  organizationPlans &&
  organizationPlans.reduce(
    (p, c) => ({
      ...p,
      [c.plan.id]: c.quantityAvailable,
    }),
    {},
  );

const queryOrganizationSubscriptions = gql`
  query organizationSubscriptions($organizationId: ID!) {
    organizationSubscriptions(organizationId: $organizationId) {
      id
      payment_type
      card {
        brand
        exp_month
        exp_year
        last4
      }
      status
      cancel_at_period_end
      created_at
      updated_at
      deleted_at
      restored_at
      items {
        id
        subscription_id
        plan_id
        plan {
          id
          name
          interval
          amount
        }
        qty
        created_at
        updated_at
        restored_at
        deleted_at
      }
      #   objectable_type
      #   objectable_id
      #   user_id
      #   created_at
      #   updated_at
      #   deleted_at
      #   restored_at
      #   items {
      #     id
      #     subscription_id
      #     plan_id
      #     qty
      #     created_at
      #     updated_at
      #     restored_at
      #     deleted_at
      #   }
    }
    organizationPlans(organizationId: $organizationId) {
      plan {
        id
        name
      }
      quantityAvailable
    }
    cards(organizationId: $organizationId) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
    }
  }
`;

const reactivateSubscription = gql`
  mutation reactivateSubscription($subscriptionId: ID!) {
    reactivateSubscription(subscriptionId: $subscriptionId) {
      id
      payment_type
      card {
        brand
        exp_month
        exp_year
        last4
      }
      cancel_at_period_end
      created_at
      updated_at
      deleted_at
      restored_at
      items {
        id
        subscription_id
        plan_id
        plan {
          id
          name
          interval
          amount
        }
        qty
        created_at
        updated_at
        restored_at
        deleted_at
      }
    }
  }
`;

const cancelSubscription = gql`
  mutation cancelSubscription($subscriptionId: ID!) {
    cancelSubscription(subscriptionId: $subscriptionId) {
      id
      payment_type
      card {
        brand
        exp_month
        exp_year
        last4
      }
      cancel_at_period_end
      created_at
      updated_at
      deleted_at
      restored_at
      items {
        id
        subscription_id
        plan_id
        plan {
          id
          name
          interval
          amount
        }
        qty
        created_at
        updated_at
        restored_at
        deleted_at
      }
    }
  }
`;

const withData = compose(
  graphql(queryOrganizationSubscriptions, {
    options: ({ params }) => ({
      variables: {
        organizationId: params.organizationId,
      },
      fetchPolicy: 'network-only',
    }),
  }),
);

const withMutation = compose(
  graphql(cancelSubscription, {
    props: ({ mutate }) => ({
      cancelSubscription: values => {
        return mutate({
          variables: values,
        });
      },
    }),
  }),
  graphql(reactivateSubscription, {
    props: ({ mutate }) => ({
      reactivateSubscription: values => {
        return mutate({
          variables: values,
        });
      },
    }),
  }),
);

@withRouter
@withData
@withMutation
@connect()
export default class OrganizationSubscriptionsList extends React.Component {
  state = {
    isCancellingOrReactivating: {},
  };

  setButtonState = (subscriptionId, status) => {
    this.setState({
      isCancellingOrReactivating: {
        [subscriptionId]: status,
      },
    });
  }

  handleReactivate = async subscriptionId => {
    const { reactivateSubscription } = this.props;
    this.setButtonState(subscriptionId, true);
    await reactivateSubscription({ subscriptionId });
    this.setButtonState(subscriptionId, false);
  };

  handleCancel = async subscriptionId => {
    const { cancelSubscription } = this.props;
    this.setButtonState(subscriptionId, true);
    await cancelSubscription({ subscriptionId });
    this.setButtonState(subscriptionId, false);
  };

  getDefaultCard = (cardsList) => {
    const result = filter(cardsList, { is_default: true });
    return result[0] || null;
  }

  render() {
    const {
      data: { organizationPlans, organizationSubscriptions, loading },
      params: { organizationId },
    } = this.props;
    if (loading) return <Loading />;
    console.log('list', this.props);
    // const defaultCard = this.getDefaultCard(cards);

    if (!organizationSubscriptions) {
      return <div>There are no subscriptions</div>;
    }

    const availableInventory = availablePlans(organizationPlans);

    return (
      <table
        className="table table-hover"
        style={{ fontFamily: 'Arial', fontSize: 14 }}
      >
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Status</th>
            <th scope="col">Plans</th>
            <th scope="col">Created</th>
            <th scope="col">Total Available</th>
            <th scope="col" />
          </tr>
        </thead>
        <tbody>
          {organizationSubscriptions.map(subscription => (
            <SuperAdminSubscriptionItem
              key={subscription.id}
              organizationId={organizationId}
              subscription={subscription}
              cancelSubscription={this.handleCancel}
              reactivateSubscription={this.handleReactivate}
              availablePlans={availableInventory}
              isCancellingOrReactivating={this.state.isCancellingOrReactivating[subscription.id]}
            />
          ))}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/OrganizationSubscriptionsList.js